exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extra-content-wrapper[data-v-0b206954]{width:100%;margin-bottom:8px}", ""]);

// exports
